import type { AxisSpec, StreamEntry } from "../ChartSpec";
import type { WindowedStreams } from "../stream-data/types";

/** Converts a raw database value to the display unit. Receives a unitCategory string (from the wire). */
export type GetConversion = (unitCategory: string) => (value: number) => number;

export type PreparedSeries = {
    streamId: number;
    color: string;
    name: string;
    points: [Date, number | null][];
};

// Bring together the spec and the stream data to produce ECharts series
export function prepareSeries(
    dataByStreamId: WindowedStreams,
    streams: StreamEntry[],
    axes: AxisSpec[],
    getConversion: GetConversion,
): PreparedSeries[] {
    if (!dataByStreamId || Object.keys(dataByStreamId).length === 0 || !streams || streams.length === 0) {
        return [];
    }

    return streams
        .filter((stream) => dataByStreamId[stream.streamId])
        .map((stream) => {
            const data = dataByStreamId[stream.streamId];
            const axis = axes.find((a) => a.id === stream.axisId);

            // Axes are built from these streams, so a matching axis always exists.
            if (!axis) {
                throw new Error(`No axis found for stream ${stream.streamId} (axisId ${stream.axisId})`);
            }

            const convert = getConversion(axis.unitCategory);

            return {
                color: stream.color,
                streamId: stream.streamId,
                name: stream.name,
                points: data.points.map((point) => [new Date(point.t), point.avg != null ? convert(point.avg) : null]),
            };
        });
}
